import PhotoSwipeLightbox from 'photoswipe/lightbox';

// Nav dropdown toggle
document.addEventListener('DOMContentLoaded', function () {
    const btn  = document.getElementById('ptfNavAlbumsBtn');
    const menu = document.getElementById('ptfNavAlbumsMenu');
    const wrap = document.getElementById('ptfNavDropdown');
    if (btn && menu && wrap) {
        btn.addEventListener('click', function (e) {
            e.stopPropagation();
            wrap.classList.toggle('open');
            menu.classList.toggle('open');
        });
        document.addEventListener('click', function () {
            wrap.classList.remove('open');
            menu.classList.remove('open');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const grid = document.getElementById('ptfPhotoGrid');
    if (!grid) return;

    // Designs mit Spalten-Markup (Kinetik) stehen im DOM spaltenweise; die Lightbox folgt dann data-index
    const isOrdered = grid.dataset.ptfOrdered === '1';
    const triggers = isOrdered
        ? Array.from(grid.querySelectorAll('a.ptf-lightbox-trigger'))
            .sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index))
        : [];

    // Voll abgedunkelt: der Standard (0.8) lässt die Seite zu stark durchscheinen
    const lightbox = new PhotoSwipeLightbox(Object.assign({ bgOpacity: 1 }, isOrdered
        ? {
            dataSource: triggers.map((el) => ({
                src: el.dataset.pswpSrc,
                width: Number(el.dataset.pswpWidth) || 0,
                height: Number(el.dataset.pswpHeight) || 0,
                msrc: el.querySelector('img')?.currentSrc,
                element: el,
            })),
            pswpModule: () => import('photoswipe'),
        }
        : {
            gallery: '#ptfPhotoGrid',
            children: 'a.ptf-lightbox-trigger',
            pswpModule: () => import('photoswipe'),
        }));

    lightbox.on('uiRegister', function () {
        lightbox.pswp.ui.registerElement({
            name: 'custom-caption',
            order: 9,
            isButton: false,
            appendTo: 'root',
            html: '',
            onInit: function (el, pswp) {
                // Mit der Maus nur einblenden, solange der Zeiger über dem Bild steht —
                // sonst verdecken lange Beschreibungen das Foto dauerhaft
                let lastPointer = null;
                el.style.transition = 'opacity .25s ease';
                const setHidden = function (hidden) {
                    el.style.opacity = hidden ? '0' : '';
                    el.style.pointerEvents = hidden ? 'none' : '';
                };
                const updateVisibility = function () {
                    const img = pswp.currSlide?.content?.element;
                    if (!lastPointer || !img) return;
                    const r = img.getBoundingClientRect();
                    setHidden(!(lastPointer.x >= r.left && lastPointer.x <= r.right
                        && lastPointer.y >= r.top && lastPointer.y <= r.bottom));
                };

                pswp.element.addEventListener('pointermove', function (e) {
                    if (e.pointerType !== 'mouse') return;
                    lastPointer = { x: e.clientX, y: e.clientY };
                    updateVisibility();
                });
                pswp.element.addEventListener('mouseleave', function () {
                    lastPointer = null;
                    setHidden(true);
                });

                pswp.on('change', function () {
                    const currSlideEl = pswp.currSlide?.data?.element;
                    const caption = currSlideEl ? (currSlideEl.dataset.caption || '') : '';
                    el.textContent = caption;
                    el.hidden = caption === '';
                    updateVisibility();
                });
                pswp.on('zoomPanUpdate', updateVisibility);
            }
        });
    });

    lightbox.init();

    triggers.forEach((el, idx) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            lightbox.loadAndOpen(idx);
        });
    });
});
